<template>
    <v-row>
        <v-col cols="12">
            <h2 class="mt-5 mb-4">{{ title }}</h2>

            <v-text-field
                v-if="showSalaryFields"
                v-model.number="details.annualSalary"
                type="number"
                label="What is your total annual salary before deductions (excluding overtime and bonuses)?"
                :required="showSalaryFields"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.annualSalary"
                prefix="£"
                min="0"
                :error="getError(`applicants.${index}.annualSalary`)"
                :error-messages="getErrorMessages(`applicants.${index}.annualSalary`)"
                @input="removeErrorMessage(`applicants.${index}.annualSalary`)"
            >
            </v-text-field>

            <v-text-field
                v-if="showSalaryFields"
                v-model.number="details.annualBonuses"
                type="number"
                label="If applicable, how much do you earn in overtime, bonuses, and commissions annually?"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                :rules="rules.annualBonuses"
                prefix="£"
                :error="getError(`applicants.${index}.annualBonuses`)"
                :error-messages="getErrorMessages(`applicants.${index}.annualBonuses`)"
                @input="removeErrorMessage(`applicants.${index}.annualBonuses`)"
            >
            </v-text-field>

            <!--
            <v-text-field
                v-model.number="details.monthlyOtherIncome"
                type="number"
                label="Monthly Other Income"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                :rules="rules.monthlyOtherIncome"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyOtherIncome`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyOtherIncome`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyOtherIncome`)"
            >
            </v-text-field>-->

            <!--
            <v-text-field
                v-model.number="details.monthlyTaxCredits"
                type="number"
                label="Monthly Tax Credits"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyTaxCredits`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyTaxCredits`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyTaxCredits`)"
            >
            </v-text-field>
            -->

            <!--
            <v-text-field
                v-model.number="details.monthlyDisabilityAllowance"
                type="number"
                label="Monthly Disability Allowance"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyDisabilityAllowance`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyDisabilityAllowance`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyDisabilityAllowance`)"
            >
            </v-text-field>
            -->

            <!--
            <v-text-field
                v-model.number="details.monthlyMaintenance"
                type="number"
                label="Monthly Maintenance"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyMaintenance`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyMaintenance`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyMaintenance`)"
            >
            </v-text-field>
            -->

            <!--
            <v-text-field
                v-model.number="details.monetaryGift"
                type="number"
                label="Monetary Gift"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                prefix="£"
                :rules="rules.monetaryGift"
                :error="getError(`applicants.${index}.monetaryGift`)"
                :error-messages="getErrorMessages(`applicants.${index}.monetaryGift`)"
                @input="removeErrorMessage(`applicants.${index}.monetaryGift`)"
            >
            </v-text-field>
            -->

            <v-text-field
                v-model.number="details.deposit"
                type="number"
                label="What is your expected deposit amount?"
                required
                outlined
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.deposit"
                prefix="£"
                :error="getError(`applicants.${index}.deposit`)"
                :error-messages="getErrorMessages(`applicants.${index}.deposit`)"
                @input="removeErrorMessage(`applicants.${index}.deposit`)"
            >
                <template v-slot:append>
                    <v-menu
                        open-on-hover
                        transition="scale-transition"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon>mdi-help-box</v-icon>
                            </v-btn>
                        </template>

                        <v-card
                            elevation="2"
                            max-width="260"
                        >
                            <v-card-text>
                                Tell us the amount of savings you are planning to put toward your deposit
                            </v-card-text>
                        </v-card>
                    </v-menu>
                </template>
            </v-text-field>

            <v-text-field
                v-model.number="details.savings"
                type="number"
                label="Please state your total savings amount"
                required
                outlined
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.savings"
                prefix="£"
                :error="getError(`applicants.${index}.savings`)"
                :error-messages="getErrorMessages(`applicants.${index}.savings`)"
                @input="removeErrorMessage(`applicants.${index}.savings`)"
            >
            </v-text-field>

            <h4 class="mt-10 mb-4">Outgoings</h4>

            <v-text-field
                v-model.number="details.monthlyCreditCardAndLoanPayments"
                type="number"
                label="Monthly credit card & loan payments"
                outlined
                hide-details="auto"
                class="rounded-0 mb-4"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyCreditCardAndLoanPayments`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyCreditCardAndLoanPayments`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyCreditCardAndLoanPayments`)"
            >
            </v-text-field>

            <h4 class="mt-10 mb-4">Declarations</h4>
            
            <legend class="v-label v-label--required theme--light mt-2 mb-2">
                Have you ever failed to keep up on a loan or any form of credit agreement?
            </legend>
            <v-radio-group
                v-model="details.failedLoanOrCreditAgreement"
                row
                :error="getError(`applicants.${index}.failedLoanOrCreditAgreement`)"
                :error-messages="getErrorMessages(`applicants.${index}.failedLoanOrCreditAgreement`)"
                @input="removeErrorMessage(`applicants.${index}.failedLoanOrCreditAgreement`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            
            <legend class="v-label v-label--required theme--light mt-4 mb-2">
                Have you ever been declared bankrupt or han an unsatisfied CCJ within the last 6 years?
            </legend>
            <v-radio-group
                v-model="details.declaredBankrupt"
                row
                :error="getError(`applicants.${index}.declaredBankrupt`)"
                :error-messages="getErrorMessages(`applicants.${index}.declaredBankrupt`)"
                @input="removeErrorMessage(`applicants.${index}.declaredBankrupt`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>
            
            <legend class="v-label v-label--required theme--light mt-4 mb-2">
                Are you entered into an IVA? (Individual Voluntary Credit Agreement)
            </legend>
            <v-radio-group
                v-model="details.enteredIVA"
                row
                :error="getError(`applicants.${index}.enteredIVA`)"
                :error-messages="getErrorMessages(`applicants.${index}.enteredIVA`)"
                @input="removeErrorMessage(`applicants.${index}.enteredIVA`)"
            >
                <v-radio
                    label="Yes"
                    :value="true"
                ></v-radio>
                <v-radio
                    label="No"
                    :value="false"
                ></v-radio>
            </v-radio-group>

            <!--
            <v-text-field
                v-model.number="details.monthlyRent"
                type="number"
                label="Monthly Rent"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                prefix="£"
                :error="getError(`applicants.${index}.monthlyRent`)"
                :error-messages="getErrorMessages(`applicants.${index}.monthlyRent`)"
                @input="removeErrorMessage(`applicants.${index}.monthlyRent`)"
            >
            </v-text-field>
            -->

            <!--
            <v-text-field
                v-model.number="details.creditCardBalance"
                type="number"
                label="Credit Card Balance"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                prefix="£"
                :error="getError(`applicants.${index}.creditCardBalance`)"
                :error-messages="getErrorMessages(`applicants.${index}.creditCardBalance`)"
                @input="removeErrorMessage(`applicants.${index}.creditCardBalance`)"
            >
            </v-text-field>
            -->

            <!--
            <v-checkbox
                v-model="details.hasLoans"
                label="Do you have loans?"
                required
                class="rounded-0 mb-4"
                hide-details="auto"
                :error="getError(`applicants.${index}.hasLoans`)"
                :error-messages="getErrorMessages(`applicants.${index}.hasLoans`)"
                @input="removeErrorMessage(`applicants.${index}.hasLoans`)"
                @change="hasLoansChanged"
            ></v-checkbox>
            -->

            <!--
            <v-text-field
                v-model.number="details.loanBalance"
                v-if="details.hasLoans"
                type="number"
                label="Loan Balance"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.loanBalance"
                prefix="£"
                :error="getError(`applicants.${index}.loanBalance`)"
                :error-messages="getErrorMessages(`applicants.${index}.loanBalance`)"
                @input="removeErrorMessage(`applicants.${index}.loanBalance`)"
            >
            </v-text-field>
            -->

            <!--
            <v-text-field
                v-model.number="details.loanPurpose"
                v-if="details.hasLoans"
                label="Loan Purpose"
                outlined
                required
                hide-details="auto"
                class="rounded-0 mb-4 v-input--required"
                :rules="rules.loanPurpose"
                :error="getError(`applicants.${index}.loanPurpose`)"
                :error-messages="getErrorMessages(`applicants.${index}.loanPurpose`)"
                @input="removeErrorMessage(`applicants.${index}.loanPurpose`)"
            >
            </v-text-field>
            -->

            <!--
            <v-menu
                ref="loanEndDateMenuRef"
                v-model="showLoanEndDatePicker"
                v-if="details.hasLoans"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="loanEndDateFormatted"
                        label="Loan End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        required
                        hide-details="auto"
                        class="rounded-0 mb-4 v-input--required"
                        :rules="rules.loanEndDate"
                        :error="getError(`applicants.${index}.loanEndDate`)"
                        :error-messages="getErrorMessages(`applicants.${index}.loanEndDate`)"
                        @input="removeErrorMessage(`applicants.${index}.loanEndDate`)"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="details.loanEndDate"
                    min="1900-01-01"
                    :active-picker.sync="loanEndDateActivePicker"
                    @change="saveLoanEndDatePicker"
                ></v-date-picker>
            </v-menu>
            -->
        </v-col>
    </v-row>
</template>

<script>
import { defineComponent, ref, onMounted, computed, watch } from '@vue/composition-api';
import {has, forEach} from "lodash";

export default defineComponent({
    name: 'Finance',
    props: [
        'accessToken',
        'index',
        'title',
        'getError',
        'getErrorMessages',
        'removeErrorMessage',
        'loggedInProfile',
        'value',
        'formDisabled'
    ],
    setup(props, { emit }) {
        const accessToken = ref(null);
        const details = ref({
            annualSalary: null,
            annualBonuses: null,
            monthlyOtherIncome: null,
            monthlyTaxCredits: null,
            monthlyDisabilityAllowance: null,
            monthlyMaintenance: null,
            monetaryGift: null,
            deposit: null,
            savings: null,
            monthlyRent: null,
            creditCardBalance: null,
            hasLoans: null,
            loanBalance: null,
            loanPurpose: null,
            loanEndDate: null,
            monthlyCreditCardAndLoanPayments: null,
            failedLoanOrCreditAgreement: null,
            declaredBankrupt: null,
            enteredIVA: null
        });
        const showLoanEndDatePicker = ref(false);
        const loanEndDateMenuRef = ref(null);
        const loanEndDateActivePicker = ref(null);

        const loanEndDateFormatted = computed(() => {
            return formatDate(details.value.loanEndDate);
        });

        const showSalaryFields = computed(() => {
            if(has(props.value,'isWorking')) {
                if(props.value.isWorking === true) {
                    return true
                }
            }
            return false
        });

        const rules = ref({
            annualSalary : [
                v => ( v >= 0 )  || 'Annual salary is required',
            ],
            annualBonuses : [
                v => ( v >= 0 ) || 'Annual bonuses is required',
            ],
            deposit : [
                v => ( v >= 0 ) || 'Deposit is required',
            ],
            savings : [
                v => ( v >= 0 ) || 'Savings is required',
            ],
            monthlyOtherIncome : [
                v => ( v >= 0 ) || 'Monthly other income is required',
            ],
            monetaryGift : [
                v => ( v >= 0 ) || 'Monetary Gift field is required',
            ],
            loanBalance : [
                v => ( v >= 0 ) || 'Loan balance is required',
            ],
            loanPurpose : [
                v => !!v || 'Loan purpose is required',
            ],
            loanEndDate : [
                v => !!v || 'Loan end date is required',
            ],
        });

        onMounted(() => {
            init();
        });

        function setFields() {
            let currentFields = {};
            forEach(details.value, function(detValue, detKey) {
                if(has(props, 'value.' + detKey)) {
                    currentFields[detKey] = props.value[detKey];
                } else {
                    currentFields[detKey] = detValue;
                }
            });

            if(currentFields.isWorking === false) {
                currentFields.annualSalary = null;
                currentFields.annualBonuses = null;
            }
            details.value = currentFields;
        }

        function hasLoansChanged(hasLoan) {
            if(hasLoan === false) {
                details.value.loanBalance = null;
                details.value.loanPurpose = null;
                details.value.loanEndDate = null;
            }
        }

        function init() {
            if(props.accessToken !== '') {
                accessToken.value = props.accessToken;
            }
            setFields();

            emit("input", props.index, details.value);
        }

        function formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`;
        }

        function saveLoanEndDatePicker(date) {
            loanEndDateMenuRef.value.save(date);
        }

        watch(details, (newData, oldData) => {
            emit("input", props.index, newData);
        }, {
            deep: true
        });

        watch(showLoanEndDatePicker, (currentValue) => {
            currentValue && setTimeout(() => (loanEndDateActivePicker.value = 'YEAR'))
        });

        watch(showSalaryFields, (currentValue) => {
            if(currentValue === false) {
                details.value.annualSalary = null;
                details.value.annualBonuses = null;
            }
        });

        return {
            details,
            showLoanEndDatePicker,
            loanEndDateFormatted,
            rules,
            loanEndDateMenuRef,
            loanEndDateActivePicker,
            showSalaryFields,
            saveLoanEndDatePicker,
            hasLoansChanged
        }
    },
})
</script>
